import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import * as pbi from 'powerbi-client';
import { PowerBIService } from '../../reports/powerbiservice.service';
import { Subscription } from 'rxjs';
import { Logger } from '../../shared/logger/logger.component';
import { IEmbedConfigurationBase } from 'embed';
import { ActivatedRoute } from '@angular/router';
import { CustomOktaAuthService } from '../../auth/oktaauth.service';

@Component({
    selector: 'app-loadreport',
    templateUrl: './loadreport.component.html',
    styleUrls: ['./loadreport.component.scss'],
    standalone: false
})
export class LoadReportComponent implements OnInit, OnDestroy {

  reportName: string;

  isLoading: boolean;
  tokenSubscription: Subscription;
  accessToken: string;

  constructor(private service: PowerBIService, private logger: Logger, private activatedRoute: ActivatedRoute, private oktaService: CustomOktaAuthService) {
    // console.log('load report constructor');
  }

  private powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory,
    pbi.factories.routerFactory);

  ngOnInit() {
    this.oktaService.refreshToken('load report component init');
    this.logger.log('load report ngOnInit');
    this.isLoading = true;

    this.activatedRoute.params.subscribe(
      params => {
        
        if (params.reportId)  {
          this.reportName = params.reportId;
        }
        else
        {
          this.reportName='Termination';
        }
        //console.log(this.reportName);
          setTimeout(() => {
            this.embedPowerBIReport();
          }, 0);
      }
    );
    

  }

  embedPowerBIReport() {
    this.tokenSubscription = this.service.getReportEmbedToken(this.reportName)
      .subscribe((response) => {
        this.isLoading = false;
        const config = <IEmbedConfigurationBase><any>{
          type: 'report',
          tokenType: pbi.models.TokenType.Embed,
          embedUrl: response.embedUrl,
          accessToken: response.accessToken,
          settings: {
            filterPaneEnabled: false
          }
        };

        // Grab the reference to the div HTML element that will host the report.
        const reportsContainer = document.getElementById('embedReport') as HTMLElement;

        const report = this.powerbi.embed(
          reportsContainer,
          config
        );

        // Report.off removes a given event handler if it exists.
        report.off('loaded');

        // Report.on will add an event handler which prints to Log window.
        report.on('loaded', (event) => {
          // console.log('loaded: ' + event);
          // this.setTokenExpirationListener(Token.expiration,
          //   2 /*minutes before expiration*/);

        });

        report.off('pageChanged');
        report.on('pageChanged', e => {
          // console.log(e);
        });

        report.on('error', (event) => {
          this.logger.log(event.detail);
          report.off('error');
        });
      },
        (error) => {
          this.logger.log(error);
        });
  }

  ngOnDestroy(): void {
    if (this.tokenSubscription) {
      this.tokenSubscription.unsubscribe();
    }
  }
}
